// api.js
import axios from 'axios';

const baseURL = '/api';

// Axios instance
const api = axios.create({
  baseURL,
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Attach the JWT to every request. The backend rejects /api calls without it.
// Login itself is public and uses plain axios, so it is unaffected.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
      // Token missing or expired -> drop the session and bounce to login.
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      }
      // global error handling
      console.error('API Error:', error);
      return Promise.reject(error);
    }
  );


// Example API call
export const fetchNotification = () => api.get('/notification');

export const fetchDashboard = () => api.get(`/dashboard`);

export const bydashboard = (id) => api.get(`/devices/by-dashboard/${id}`);
export const totalDevices = () => api.get(`/devices`);
export const totalcustomer = () => api.get(`/customer`);
export const asset = () => api.get(`/asset`);

export const users = () => api.get(`/users`);

export const systeminfo = () => api.get(`/systeminfo`);

//post method
export const createDocument = (data) => api.post(`/document`, data);

export const feachDocument = () => api.get(`/document`);

export const updateDocument = (id, data) => api.put(`/document/${id}`, data);

export const graphData=(id)=>api.get(`/graphdata/${id}`);

export const graphdataPost = (data) => api.post(`/graphdata`, data);



export const telemetrydata = (id,startts,endts) => api.get(`/device/telemetry/${id}?startTs=${startts}&endTs=${endts}`);

export const timeSeries = (id,startts,endts) => api.get(`time-series/${id}?startTs=${startts}&endTs=${endts}`);
// device/telemetry/time-series/

